import { render, staticRenderFns } from "./SpindleSpeedPanel.vue?vue&type=template&id=a5077cd6&scoped=true&"
import script from "./SpindleSpeedPanel.vue?vue&type=script&lang=js&"
export * from "./SpindleSpeedPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpindleSpeedPanel.vue?vue&type=style&index=0&id=a5077cd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5077cd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCardTitle,VCombobox,VIcon,VSimpleTable})
